"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _colors = require("HubStyleTokens/colors");

var CalculatorDivider = (0, _styledComponents.default)(_HR.default).withConfig({
  displayName: "CalculatorDivider",
  componentId: "sc-1v9fi9n-0"
})(["width:28px;margin:28px 0;color:", ";border-color:", ";background-color:", ";"], _colors.BATTLESHIP, _colors.BATTLESHIP, _colors.BATTLESHIP);
var _default = CalculatorDivider;
exports.default = _default;
module.exports = exports.default;